module.exports = __webpack_public_path__ + "img/lxwm.d9b69940.png";